// Constantes del ABM de usuarios internos.

export { GENEROS } from "consts/generos";

/**
 * Tipo de documento con el que se busca y se da de alta.
 *
 * Fijo en DNI: este panel administra usuarios internos del organismo, no público
 * general. `usuarioBasicosGet` lo acepta sin el tipo —la búsqueda es por número, sexo y
 * fecha de nacimiento, igual que en el alta de agentes— pero `MIAConnectionIns` sí lo
 * pide para crear la persona.
 */
export const TIPO_DOCUMENTO = "DNI";

/**
 * El rol de Administrador.
 *
 * Un administrador puede CREAR cualquiera de los tres roles, pero no puede MODIFICAR a otro
 * administrador. Como el se tiene ese rol, la misma regla le impide modificarse a si mismo:
 * no hace falta comparar contra el usuario conectado.
 *
 * Es el unico lugar del panel que necesita reconocer un rol puntual, asi que el criterio vive
 * aca y no repartido por la vista.
 *
 * Por COD y no por nombre: es el dato estable. Un renombre del rol en el back no tiene por que
 * desactivar una regla de permisos.
 */
export const ROL_ADMINISTRADOR_COD = "MA";

export const esRolAdministrador = (rolCod) => rolCod === ROL_ADMINISTRADOR_COD;

/**
 * Estado del VÍNCULO del usuario con el servicio, no de la persona.
 *
 * Son los mismos códigos y las mismas transiciones que usa la administración de
 * usuarios por servicio: de un estado solo se puede pasar a los que su fila permite.
 * Por ejemplo, una baja no vuelve atrás.
 */
export const ESTADOS_CONEXION = [
    { cod: "P", label: "Pendiente" },
    { cod: "A", label: "Activo" },
    { cod: "B", label: "Baja" },
    { cod: "S", label: "Suspendido" },
    { cod: "X", label: "Cancelado" },
    { cod: "R", label: "Rechazado" },
];

/**
 * La baja es TERMINAL: un usuario dado de baja no lo edita nadie, ni siquiera un
 * administrador.
 *
 * `TRANSICIONES` ya dejaba a "B" sin salida, asi que el selector de estado no ofrecia como
 * revertirla — pero el modal igual se abria y desde ahi se podian cambiar el rol y el mail.
 * Por eso la regla va en el boton y no solo en el selector.
 */
export const ESTADO_BAJA_COD = "B";

export const estaDeBaja = (estadoCod) => estadoCod === ESTADO_BAJA_COD;

const TRANSICIONES = {
    P: ["P", "X"],
    A: ["A", "B", "S"],
    B: ["B"],
    S: ["S", "A"],
    X: ["X", "P"],
    R: ["R", "B"],
};

/** A qué estados puede pasar el vínculo desde el que tiene hoy. */
export const estadosPosibles = (codActual) =>
    codActual
        ? ESTADOS_CONEXION.filter((e) => TRANSICIONES[codActual]?.includes(e.cod))
        : ESTADOS_CONEXION;
